import { render } from "./SearchSVG.vue?vue&type=template&id=c4d6a20a"
const script = {}

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__